// @ts-nocheck
import throttle from "lodash/throttle";
import { useEffect, useState } from "react";
/**
 *
 * @param itemsPerPage - number of items to show per page
 * @param startInfiniteScroll - whether to start infinite scroll on mount
 * @returns {page, itemsToShow, setPage} - page is the current page, itemsToShow is the number of items to show, setPage is a function to set the page
 *
 */

const useInfinteScroll = (itemsPerPage = 10, startInfiniteScroll = true) => {
    const [page, setPage] = useState(1);

    useEffect(() => {
        const handleScroll = throttle(() => {
            if (document.documentElement.scrollTop < document.body.scrollHeight - window.innerHeight * 4) {
                return;
            }
            setPage(page => page + 1);
        }, 300);

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, [startInfiniteScroll]);
    return { page, itemsToShow: page * itemsPerPage, setPage };
};

export default useInfinteScroll;
